import type React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { BusinessReportOutcomeHeaderMenu } from "./businessReportOutcomeHeaderMenu";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails | null;
}

export const BusinessReportOutcomeHeader: React.FC<Props> = ({ businessReportOutcome }) => {
  const user = useAuthenticatedUser();

  const isOwner = businessReportOutcome?.permissions.some(
    permission => permission.user_id === user.id && permission.role === "owner",
  );

  return (
    <div className="flex">
      <h1 className="text-2xl font-bold">{businessReportOutcome?.business_report.name || "SnapShot"}</h1>
      {isOwner && businessReportOutcome && (
        <BusinessReportOutcomeHeaderMenu businessReportOutcome={businessReportOutcome} />
      )}
    </div>
  );
};
